import { Component, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { AgGridDataModelAllocations, AgGridDataModelLineHistory, AgGridDataModelLineInfo, AgGridDataModelViewLineInfo } from '../../part-list.model';
import { AgGridComponent } from '../../../../../shared/components/ag-grid/ag-grid.component';
import { SendDataService } from '../../../../../shared/services/send-data.service';
import { ImagesComponent } from '../images/images.component';
import { ModalPopupSize } from '../../../../../shared/model/common.model';
import { SerialNumbersComponent } from '../serial-numbers/serial-numbers.component';
import { PartsListService } from '../../pages/parts-list/parts-list.service';
import { LineHistoryPaginationModel } from '../../../../../shared/components/ag-grid/ag-grid.model';
import { GridName } from '../../../../crm/crm.model';
import { StorageService } from '../../../../../shared/services/storage.service';

@Component({
  selector: 'app-view-consignment-tab',
  templateUrl: './view-consignment-tab.component.html',
  styleUrls: ['./view-consignment-tab.component.scss'],
})
export class ViewConsignmentTabComponent implements OnInit {
  active   = 1;
  agGridDataModelLineInfo;
  lineInfoGridApi;
   @Input() data:any ={};
   lineHistoryModel = new LineHistoryPaginationModel();
  @ViewChildren(AgGridComponent) grids: QueryList<AgGridComponent>
  tabData1 = [
    { id: 1, label: 'Line Information', dataModel: AgGridDataModelViewLineInfo,pagination:false },
    { id: 2, label: 'Receive Details', dataModel: AgGridDataModelViewLineInfo ,pagination:false},
    { id: 3, label: 'Allocations', dataModel: AgGridDataModelAllocations ,pagination:true},
    { id: 4, label: 'Quality', dataModel: AgGridDataModelViewLineInfo ,pagination:false},
    { id: 5, label: 'Quotes', dataModel: AgGridDataModelViewLineInfo,pagination:false },
    { id: 6, label: 'POs', dataModel: AgGridDataModelViewLineInfo,pagination:false},
    { id: 7, label: 'WOs', dataModel: AgGridDataModelViewLineInfo,pagination:false},
    { id: 8, label: 'Invoices', dataModel: AgGridDataModelViewLineInfo ,pagination:false},
    { id: 9, label: 'RMAs', dataModel: AgGridDataModelViewLineInfo,pagination:false},
    { id: 10, label: 'RTVs', dataModel: AgGridDataModelViewLineInfo ,pagination:false},
    { id: 11, label: 'Line History', dataModel: AgGridDataModelLineHistory,pagination:true},
  ];

  tabData2 = [
    { id: 1, label: 'Line Information', dataModel: AgGridDataModelViewLineInfo,pagination:false},
  ]
  tabData:any = []
  constructor(public sendDataService: SendDataService,
    public partsListService: PartsListService,
     public storageService: StorageService,
  ) { }

  ngOnInit(): void {
   //    this.agGridDataModelLineInfo = AgGridDataModelViewLineInfo;
       this.tabData = this.data.inventoryLineDetail? this.tabData1:this.tabData2;
  }
  onGridReady(event){
    this.lineInfoGridApi = event;
    this.getListData()
  }
  getListData(){
    this.partsListService.getInfoList().subscribe((res)=>{
      if(res?.inventoryLineModel?.length > 0){
        let list = res?.inventoryLineModel;
        if (this.grids?.first) {
          switch(this.active){
            case 1:
              this.grids.first.agGridPaginationConfig.rows = list
           break;
           case 11:
            this.getLineHistory(res)
         break;
           default:
            this.grids.first.agGridPaginationConfig.rows = []
            break;
          }
        }
    
      }
    })
  }
  onPagination($event){
    switch(this.active){
    case 11:
      let model = this.grids?.first?.agGridPaginationConfig
      this.lineHistoryModel.pageNumber = model?.currentPageNumber;
      this.lineHistoryModel.pageSize = model?.pageSize;
      this.lineHistoryModel.getAll = model?.pageSize == 1 ? true : false;
      this.getLineHistory(this.lineHistoryModel);
    break;
    }
  }
  getLineHistory(event){
      if(!event.inventoryLineId)return
              this.lineHistoryModel.inventoryLineId = event.inventoryLineId
              if (this.grids?.first){ 
                this.grids.first.agGridPaginationConfig.rows = []
                this.grids.first.showLoading(this.lineInfoGridApi);
                   this.partsListService.getLineHistoryList(this.lineHistoryModel).subscribe({
                    next : (res) =>{
                      if(res?.isSuccess) {
                        this.grids.first.hideLoading(this.lineInfoGridApi);
                        this.lineInfoGridApi?.api?.setRowData(res?.response??[]);
                        if(!res?.response?.length){this.grids.first.agGridPaginationConfig.rows = []}
                       this.grids.first.updatePaginationData(this.lineHistoryModel,res.totalRecords);
                      } else {
                        this.grids.first.hideLoading(this.lineInfoGridApi);
                        this.lineInfoGridApi?.api?.setRowData([]);
                      }
                    },
                    error : (err) => {
                      this.grids.first.hideLoading(this.lineInfoGridApi);
                      this.lineInfoGridApi?.api?.setRowData([]);
                    }
                   })
              }
    
  }
  getRowStyle = (params: any) => {
    return { borderBottom: '1px solid #E9EDF2' };
  }
  activeTab(id) {
    this.active = id;
  }
onImageIconClick(event) {
  const params = event?.detail?.data?.data;
  this.openImagesPopup(params) 
}
  openImagesPopup(params) {
    const data = {
     inventoryLineId:params?.inventoryLineId,
      editable:true
     }
 
    this.sendDataService.openModalPopup(ImagesComponent, data, 'Images', ModalPopupSize.LG,'images-popup has-parent-popup').then(
      (resultData) => {
        if (resultData) {
          if (resultData.success) {

          }
        }
      }
    );
  }
  onSerialNumberClick(event){
    const params = event?.detail?.data?.data;
    this.openSerialNumbersPopup(params) 
  }
  openSerialNumbersPopup(params){
    const data = {
     serialNumber:params?.serialNumberModel,
     title:params?.serialNumberModel?.length > 0 ?'Edit':'Save',
     disable:true
    }
    this.sendDataService.openModalPopup(SerialNumbersComponent, data, 'Serial Number(s)', ModalPopupSize.MD, 'has-parent-popup').then(
      (resultData) => {
        if (resultData) {
          if (resultData.success) {

          }
        }
      }
    ); 
  }

}
